import { Capacitor } from '@capacitor/core'
import { StatusBar } from '@capacitor/status-bar'

/**
 * Native shell tweaks when the app runs inside the Capacitor WebView
 * (Rails is loaded via server.url — this code ships with the webpack pack).
 */
export function initCapacitorNativeShell () {
  if (!Capacitor.isNativePlatform()) return

  StatusBar.setOverlaysWebView({ overlay: false }).catch(() => {})
}
